// @flow
export { default } from './TrendingSection';



// WEBPACK FOOTER //
// ./src/components/trending/TrendingSection/index.js